import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import elderVideo from "./images/elder.mp4";

function ElderHome() {
  const navigate = useNavigate();
  const { t } = useTranslation("home");

  return (
    <div className="page-shell">
      <section className="page-panel role-page role-page-elder">
        <div className="page-content">
          <div className="role-hero-layout">
            <div>
              <div className="intro-badge">{t("elderPage.badge")}</div>
              <h1 className="page-title">{t("elderPage.title")}</h1>
              <p className="page-subtitle">{t("elderPage.subtitle")}</p>

              <div className="role-highlight-card">
                <div className="mini-label">{t("elderPage.highlightLabel")}</div>
                <h3>{t("elderPage.highlightTitle")}</h3>
                <p>{t("elderPage.highlightText")}</p>
              </div>

              <div className="section-block">
                <h2 className="section-title">{t("elderPage.sectionTitle")}</h2>
                <div className="role-checklist">
                  <RolePoint
                    title={t("elderPage.points.point1Title")}
                    text={t("elderPage.points.point1Text")}
                  />
                  <RolePoint
                    title={t("elderPage.points.point2Title")}
                    text={t("elderPage.points.point2Text")}
                  />
                  <RolePoint
                    title={t("elderPage.points.point3Title")}
                    text={t("elderPage.points.point3Text")}
                  />
                </div>
              </div>

              <div className="hero-actions">
                <button className="button" onClick={() => navigate("/elder-login")}>
                  {t("elderPage.actions.login")}
                </button>
                <button className="ghost-button" onClick={() => navigate("/elder-register")}>
                  {t("elderPage.actions.register")}
                </button>
              </div>
            </div>

            <div className="role-media-stack">
              <div className="hero-card hero-visual media-card role-video-card">
                <div className="media-label">{t("elderPage.mediaLabel")}</div>
                <video className="hero-video elder-video" autoPlay muted loop controls>
                  <source src={elderVideo} type="video/mp4" />
                </video>
              </div>

              <div className="feature-card role-summary-card">
                <div className="mini-label">{t("elderPage.summaryLabel")}</div>
                <h3>{t("elderPage.summaryTitle")}</h3>
                <p>{t("elderPage.summaryText")}</p>
              </div>
            </div>
          </div>

          <div className="section-block">
            <h2 className="section-title">{t("elderPage.journeyTitle")}</h2>
            <div className="steps-grid" style={{ marginTop: "1rem" }}>
              <StepCard
                number="1"
                title={t("elderPage.journey.step1Title")}
                text={t("elderPage.journey.step1Text")}
              />
              <StepCard
                number="2"
                title={t("elderPage.journey.step2Title")}
                text={t("elderPage.journey.step2Text")}
              />
              <StepCard
                number="3"
                title={t("elderPage.journey.step3Title")}
                text={t("elderPage.journey.step3Text")}
              />
              <StepCard
                number="4"
                title={t("elderPage.journey.step4Title")}
                text={t("elderPage.journey.step4Text")}
              />
            </div>
          </div>

          <section className="homepage-marketing-link">
            <div>
              <div className="mini-label">Marketing page</div>
              <h3>Open the full elder marketing experience.</h3>
              <p>
                View the dedicated standalone-style page with the same logo and elder guide video
                used in the app.
              </p>
            </div>
            <Link className="ghost-button homepage-marketing-link-button" to="/elder-marketing">
              View Elder Marketing Page
            </Link>
          </section>
        </div>
      </section>
    </div>
  );
}

function RolePoint({ title, text }) {
  return (
    <div className="journey-step">
      <div className="step-number">E</div>
      <div>
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </div>
  );
}

function StepCard({ number, title, text }) {
  return (
    <div className="step-card">
      <div className="step-number">{number}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

export default ElderHome;
